import { PageRouteBuilder } from "@common/route/page-route-builder";
import { McpOAuthClientsPageComponent } from "./mcp-oauth-clients-page.component";

export const mcpOAuthClientsPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-mcp-oauth-clients-page", McpOAuthClientsPageComponent)
    .requiresLogin()
    .atUrl("/tools/mcp-oauth-clients")
    .withTitle("MCP OAuth Clients")
    .build();
